<script>
import SearchBar from '@/components/common/SearchBar.vue'
import intPage from '@/mixin/intPage.js'
import blockHover from '@/mixin/blockHover.js'
import PagenationContainer from '@/components/common/PagenationContainer.vue'
import acount_lock from '@/assets/acount_lock.svg'
import acount_unlock from '@/assets/acount_unlock.svg'
import CheckPwdDialog from '@/components/acount/CheckPwdDialog.vue'
import AddAcountDialog from '@/components/acount/AddAcountDialog.vue'
import ResetPwdDialog from '@/components/acount/ResetPwdDialog.vue'
import {acountList} from '@/router/default.js'
import PurchaseDialog from '@/components/acount/PurchaseDialog.vue'

export default {
    mixins: [
        intPage,
        blockHover
    ],
    components: {
        SearchBar,
        PagenationContainer,
        CheckPwdDialog,
        AddAcountDialog,
        ResetPwdDialog,
        PurchaseDialog
    },
    props: {
        urlPage: String,
        urlSearchType: String,
        urlSearchText: String
    },
    data() {
        return {
            searchText: '',
            searchType: '帐号',
            pageCount: 0,
            locked: true,
            acounts: [],
            addingUser: false,
            validatingPwd: false,
            deletingAcount: null,
            resetingPwdAcount: null,
            purchaseAcount: null,
            isData:false,
            isProductinformation: "",
            homeId: ""
        }
    },
    computed: {
        lockImg() {
            if (this.locked) {
                return acount_lock
            } else {
                return acount_unlock
            }
        },
        showChangePwd() {
            return this.changingPwd || this.forceChangingPwd
        },
        inElectron() {
            return this.$electron
        },
        showProductinformation() {
            return this.isProductinformation == 'true';
        }
    },
    created() {
        this.decodeFromUrl()
        this.reload()
        this.homeId = this.$cookie.get('id');
        this.isProductinformation = this.$cookie.get('showPrompt');
    },
    provide() {
        return {
            totalReload:this.totalReload,
            reload: this.reload
        }
    },
    methods: {
        encodeToUrl(params) {
            this.$router.replace(`/index/acountList/${params.page?params.page:this.urlPage}/${params.searchType?params.searchType:this.urlSearchType}/${params.searchText?params.searchText:this.urlSearchText}`)
            this.$nextTick(this.reload)
        },
        decodeFromUrl() {
            this.searchType = this.urlSearchType
            this.searchText = (this.urlSearchText == '-1')?'':this.urlSearchText
        },
        optionChanged(option) {
            this.searchType = option
        }, 
        search() {
            this.encodeToUrl({
                searchType: this.searchType,
                searchText: this.searchText?this.searchText:'-1',
                page: 1
            })
        },
        pageClick(page) {
            this.encodeToUrl({
                page: page
            })
        },
        totalReload() {
            this.$router.replace(acountList)
            this.$nextTick(() => {
                this.decodeFromUrl()
                this.reload()
            })
        },
         async reload() {
             let params = {
                page: this.intPage - 1,
             }
             if (this.urlSearchText != -1) {                                                   
                switch (this.urlSearchType) {
                    case '账号':
                        params.id = this.urlSearchText
                        localStorage.setItem('id',this.urlSearchText)
                        break;
                    case '患者姓名':
                        params.name = this.urlSearchText
                        break;
                    case '联系人':
                        params.contact = this.urlSearchText
                        break;
                    case '联系电话':
                        params.phone = this.urlSearchText
                        break;
                }
            }
            let data = await this.$http.getAcountList(params)
            if (data) {                
                this.pageCount = data.totalPages
                this.acounts = data.content 
            }
            if(this.acounts.length===0){
                this.isData = true
            }
            else{
                this.isData = false
            }
        },
        acountClick(acount) {
            if (!acount.enabled) {
                return 
            }
            this.$router.push(`/index/acountInfo/${acount.id}/${this.urlPage}/${this.urlSearchType}/${this.urlSearchText}`)
        },
        toggleLock() {
            if (this.locked) {
                this.validatingPwd = true
            } else {
                this.locked = true
            }
        },
        pwdChecked() {
            this.locked = false
            this.validatingPwd = false
        },
         async toggleEnable(acount) {
            if (this.locked) {
                return
            }
            let result = await this.$http.updateAcount(acount.id, {enabled: !acount.enabled})
            if (result) {
                acount.enabled = !acount.enabled
            }
        },
        prepareToResetPwd(acount) {
            if (this.locked) {
                return
            }
            this.resetingPwdAcount = acount
        },
        prepareToDeleteAcount(acount) {
            if (this.locked) {
                return
            }
            this.deletingAcount = acount
        },
        async deleteAcount() {
            let result = await this.$http.deleteAcount(this.deletingAcount.id)
            if (result) {
                this.deletingAcount = null
                this.reload()
            }
        },
        prepareToPurchase(acount) {
            if (!acount.enabled) {
                return
            }
            this.purchaseAcount = acount
        },
        payed() {
            this.purchaseAcount = null
            this.reload()
        },
        closeProductionLog() {
            this.isProductinformation = false;
        },
        async ikonwProductionLog(checked) {
            checked = !checked;
            let data = await this.$http.changeShowPrompt(this.homeId, checked);
            this.$cookie.set('showPrompt', checked);
            this.isProductinformation = false;
        }
    }
}
</script>

<template>
    <div class="container">
        <div class="coverup" v-if="showProductinformation">
            <Productinformation v-if="showProductinformation" :hide-close="false" @close="closeProductionLog" @confirm="ikonwProductionLog" :platform="inElectron?'PC端':'WEB端'"  ></Productinformation>
        </div>
        <div class="AcountList" v-if="!showProductinformation" >
            <PurchaseDialog v-if="purchaseAcount" @close="purchaseAcount = null" :is-new="!purchaseAcount.trainingCount" :patient-id="purchaseAcount.id" @payed="payed" />
            <CheckPwdDialog v-if="validatingPwd" @close="validatingPwd = false" @checked="pwdChecked" />
            <Dialog v-if="deletingAcount" title="确定删除这个账户吗？" @confirm="deleteAcount" @close="deletingAcount = null" simple />
            <AddAcountDialog v-if="addingUser" @close="addingUser = false" />
            <ResetPwdDialog v-if="resetingPwdAcount" :acount="resetingPwdAcount" @close="resetingPwdAcount = null" />
            <div class="header" >
                <SearchBar v-model.trim="searchText" @option-changed="optionChanged" @search="search" :options="['帐号', '患者姓名', '联系人', '联系电话']">{{searchType}}</SearchBar>
                <Btn @click="addingUser = true" >添加账户</Btn>
            </div>
            <div class="table" :class="{lockedTable: locked}" >
                <div class="tr" >
                    <div style="width: 20.4%" class="th" >创建时间</div>
                    <div style="width: 14.1%" class="th" >账号</div>
                    <div style="width: 9.2%" class="th" >患者姓名</div>
                    <div style="width: 9.2%" class="th" >联系人</div>
                    <div style="width: 12.7%" class="th" >联系电话</div>
                    <div style="width: 9.2%" class="th" >剩余训练次数</div>
                    <div style="width: 8.5%" class="th" >购买疗程</div>
                    <div style="width: 16.7%" class="th" >操作
                        <img class="lockBtn" @click="toggleLock" :src="lockImg">
                    </div>
                </div>
                
                <div class="tb" :class="{hoverAble: !hoverBlocked}" >
                    <div class="data" v-if="isData">暂无数据</div>
                    <div class="tr" v-for="acount in acounts" :key="acount.id" :class="{disabledTr: !acount.enabled}" @click="acountClick(acount)"  >
                        <div style="width: 20.4%" class="td" >{{moment(acount.createdAt, 'YYYY-MM-DD HH:mm:ss')}}</div>
                        <div style="width: 14.1%" class="td" >{{acount.id}}</div>
                        <div style="width: 9.2%" class="td" >{{acount.name}}</div>
                        <div style="width: 9.2%" class="td" >{{acount.contact}}</div>
                        <div style="width: 12.7%" class="td" >{{acount.phone}}</div>
                        <div style="width: 9.2%" class="td" >{{acount.trainingCount}}次</div>
                        <div style="width: 8.5%" class="td" >
                            <Btn @mouseenter.native="blockHover" :disabled="!acount.enabled" @mouseleave.native="unblockHover" @click.stop.native="prepareToPurchase(acount)" >{{acount.trainingCount?'续费':'购买'}}</Btn>
                        </div>
                        <div style="width: 16.7%" class="td" >
                            <div class="operationArea" :class="{operationAreaLocked: locked}" >
                                <span class="operationBtn" @mouseenter="blockHover" @mouseleave="unblockHover" @click.stop="toggleEnable(acount)" >{{acount.enabled?'停用':'启用'}}</span>
                                <div class="line" ></div>
                                <span class="operationBtn" @mouseenter="blockHover" @mouseleave="unblockHover" @click.stop="prepareToResetPwd(acount)" >重置密码</span>
                                <div class="line" ></div>
                                <span class="operationBtn" @mouseenter="blockHover" @mouseleave="unblockHover" @click.stop="prepareToDeleteAcount(acount)" >删除</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PagenationContainer v-if="pageCount > 1">
                <el-pagination :current-page="intPage" @current-change="pageClick" :page-count="pageCount" background layout=" prev, pager, next, jumper" />
            </PagenationContainer>
        </div>
    </div>

</template>

<style lang="scss" scoped>
@import '@/css/color.scss';
.container {
    height: 100%;
    width: 100%;
}
.coverup{
    height: 100%;
    width: 100%;
}
.AcountList {
    height: 100%;
    width: 100%;
    overflow: auto;
    .header {
        height: 70px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        padding-right: 17px;
        align-items: center;
        border-bottom:1px solid rgba(222,228,236,1);
        .Btn {
            width: 110px;
            height: 37px;
            border-radius: 3px;
            margin-left: 20px;
            font-size: 16px;
        }
        .SearchBar {
            width: 289px;
            height: 36px;
        }
    }
    .table {
        
        .tr {
            display: flex;
            // grid-template-columns: 20.4% 14.1% 9.2% 9.2% 12.7% 9.2% 8.5% 16.7%;
        }
        .th,.td {
            display: flex;
            align-items: center;
            box-sizing: border-box;
            &:first-child {
                padding-left: 42px;
            }
        }
        .th {
            height: 45px;
            background-color: #F4F8FB;
            color: #0A2136;
            .lockBtn {
                margin-left: 8px;
                cursor: pointer;
            }
        }
        .td {
            color: #595959;
            height: 55px;
            border-bottom:1px solid rgba(242,246,251,1);
            .Btn {
                width: 56px;
                height: 29px;
                border-radius: 3px;
            }
            .operationArea {
                width: 157px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                >span {
                    cursor: pointer;
                    color: $mainPurple;
                }
                .line {
                    width: 1px;
                    background-color: #595959;
                    height: 70%;
                }
            }
            .operationAreaLocked {
                >span {
                    color: #ddd;
                }
            }
        }
        .hoverAble .tr {
            &:hover {
                background-color: #FCFDFF;
            }
        }
        .tb {
            .tr {
                cursor: pointer;
            }
            .disabledTr {
                cursor: auto;
                .td {
                    color: #C8C8C8;
                }
                &:hover {
                    background-color: #fff;
                }
            }
        }
    }
    .lockedTable {
        .operationBtn {
            cursor:not-allowed !important;
        }
    }
    .data{
    display:flex;
    justify-content: center;
    font-size:20px;
    margin:40px 0;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/acount/AcountList.vue